import React, { createContext, useContext, useMemo, useState } from 'react';
import useVAFeatureFlags from 'src/hooks/useVAFeatureFlags';

// Shares the Copilot open-state between its launcher (the header help-icon slot,
// in AppBar) and the drawer (CopilotWidget), which live in different parts of
// the tree. The default value makes useCopilot() safe outside a provider (e.g.
// the patient AppBar) — it just reports disabled.
const CopilotContext = createContext({
  enabled: false,
  isOpen: false,
  open: () => {},
  close: () => {},
  toggle: () => {}
});

export function CopilotProvider({ children }) {
  const flags = useVAFeatureFlags();
  const [isOpen, setIsOpen] = useState(false);
  const enabled = !!(flags && flags.copilotEnabled);

  const value = useMemo(
    () => ({
      enabled,
      isOpen,
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
      toggle: () => setIsOpen((v) => !v)
    }),
    [enabled, isOpen]
  );

  return (
    <CopilotContext.Provider value={value}>{children}</CopilotContext.Provider>
  );
}

export function useCopilot() {
  return useContext(CopilotContext);
}
